export const zaiusSubscribe = () => {
  if (sessionStorage.getItem('Email') && window?.zaius) {
    const newsletter = 'newsletter';
    const alert = 'alerts';
    const promo = 'promo';
    const email = sessionStorage.getItem('Email');
    if (email) {
      const parsedEmail = JSON.parse(email);

      const { zaius } = window;

      zaius.customer({
        email: parsedEmail,
      });

      zaius.subscribe({
        list_id: newsletter,
        email: parsedEmail,
      });

      zaius.subscribe({
        list_id: alert,
        email: parsedEmail,
      });
      zaius.subscribe({
        list_id: promo,
        email: parsedEmail,
      });
    }
  }
};
